import { primitive } from 'styles/constants/primitives';

import { G, Mask, Path, Rect, Svg } from '../../../ucl/components/svg/Svg';

export const NewBadgeIcon = () => (
  <Svg
    width={12}
    height={13}
    viewBox="0 0 12 13"
    fill="none"
    alignSelf={'center'}
    color={primitive.bk.$bbqBrown}
  >
    <Mask
      id="mask0_7983_1903"
      // style={{
      //   maskType: 'alpha',
      // }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={12}
      height={13}
    >
      <Rect y={0.397461} width={12} height={12} fill="#D9D9D9" />
    </Mask>
    <G mask="url(#mask0_7983_1903)">
      <Path
        d="M8.35 7.64744L10.25 6.02244L10.575 6.04744C10.7167 6.0641 10.8271 6.12244 10.9062 6.22244C10.9854 6.32244 11.025 6.43077 11.025 6.54744C11.025 6.6141 11.0125 6.68077 10.9875 6.74744C10.9625 6.8141 10.9167 6.87244 10.85 6.92244L9.55 8.05994L9.9375 9.74744C9.94583 9.7641 9.95 9.78285 9.95 9.80369V9.85994C9.95 10.0016 9.9 10.1204 9.8 10.2162C9.7 10.312 9.58333 10.3599 9.45 10.3599C9.40833 10.3599 9.36458 10.3537 9.31875 10.3412C9.27292 10.3287 9.22917 10.3099 9.1875 10.2849L8.925 10.1224L8.35 7.64744ZM7.175 3.99744L6.65 2.77244L6.7625 2.49744C6.80417 2.39744 6.86875 2.32035 6.95625 2.26619C7.04375 2.21202 7.13333 2.18494 7.225 2.18494C7.31667 2.18494 7.40625 2.20994 7.49375 2.25994C7.58125 2.30994 7.64583 2.38494 7.6875 2.48494L8.375 4.10994L7.175 3.99744ZM3.675 8.80994L5.25 7.85994L6.825 8.82244L6.4125 7.02244L7.8 5.82244L5.975 5.65994L5.25 3.95994L4.525 5.64744L2.7 5.80994L4.0875 7.02244L3.675 8.80994ZM2.425 9.74744L2.975 7.38494L1.1375 5.79744C1.07083 5.74744 1.02708 5.6891 1.00625 5.62244C0.985417 5.55577 0.975 5.4891 0.975 5.42244C0.975 5.30577 1.01458 5.19744 1.09375 5.09744C1.17292 4.99744 1.28333 4.9391 1.425 4.92244L3.85 4.70994L4.7875 2.48494C4.82917 2.38494 4.89375 2.30994 4.98125 2.25994C5.06875 2.20994 5.15833 2.18494 5.25 2.18494C5.34167 2.18494 5.43125 2.20994 5.51875 2.25994C5.60625 2.30994 5.67083 2.38494 5.7125 2.48494L6.65 4.70994L9.075 4.92244C9.21667 4.9391 9.32708 4.99744 9.40625 5.09744C9.48542 5.19744 9.525 5.30577 9.525 5.42244C9.525 5.4891 9.51458 5.55577 9.49375 5.62244C9.47292 5.6891 9.42917 5.74744 9.3625 5.79744L7.525 7.38494L8.075 9.74744C8.08333 9.77244 8.0875 9.80994 8.0875 9.85994C8.0875 10.0016 8.0375 10.1204 7.9375 10.2162C7.8375 10.312 7.72083 10.3599 7.5875 10.3599C7.5625 10.3599 7.475 10.3349 7.325 10.2849L5.25 9.03494L3.175 10.2849C3.13333 10.3099 3.08958 10.3287 3.04375 10.3412C2.99792 10.3537 2.95417 10.3599 2.9125 10.3599C2.7625 10.3599 2.63333 10.2995 2.525 10.1787C2.41667 10.0579 2.38333 9.9141 2.425 9.74744Z"
        fill="#502314"
      />
    </G>
  </Svg>
);
